/**
 * @Author: 36 Pixels <imac>
 * @Date:   06/04/2017, 3:37:39
 * @Email:  anais@36pixels.fr
 * @Project: First Pixel
 * @Filename: fullscreen.js
 * @Last modified by:   imac
 * @Last modified time: 15/09/2017, 6:44:25
 * @License: (c) 2017 by 36 Pixels. All Rights Reserved.
 */



function setFullscreen(){
    var imgBG = document.querySelectorAll('div.fullscreen');

    if ( imgBG ) {
        var hauteur = window.innerHeight;
        var admin = document.getElementById('wpadminbar');
        var adminHeight = admin !== null ? admin.clientHeight : 0;
        var menu = document.getElementById('header');
        var menuHeight = menu !== null ? menu.clientHeight : 0;
        for(var i = 0; i < imgBG.length; i++){
            imgBG[i].style.height = (hauteur - adminHeight - menuHeight) + 'px';
        }
    }
}

module.exports = function () {
    window.addEventListener('resize', setFullscreen);
    setFullscreen();
};
